import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import ContactMain from "./ContactMain";
import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";

const Contact = () => {
  return (
    <>
      <Header parentMenu="contact" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Contact" />

          <ContactMain />

          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contact;
